import { cva } from 'class-variance-authority';

/**
 * Popover class recipes — an anchored surface holding arbitrary content.
 *
 * The surface is Menu's, by decision rather than coincidence: the Figma proposal (node 1912:113967)
 * specifies `background/control`, `border/control`, `radius/md`, x2 padding, and Menu's shadow, so a
 * popover and a menu opened side by side read as one family. The colours come from `.ds-popover` in
 * `design-system.css`, which points at the same roles as `.ds-menu` — change them together.
 *
 * What it does NOT copy from Menu: the 220px floor and the row gap. A popover sizes to its content
 * (the emoji reactions bar is one row of 40px cells), and its content lays itself out.
 */
export const popoverPanelRecipe = cva([
  'ds-popover',
  'box-border w-max',
  'ds-popup-scroll max-h-[var(--available-height)] max-w-[var(--available-width)] overflow-auto overscroll-contain',
  'p-[8px]',
  'rounded-[16px]',
  'border-solid border-[length:1px] border-[var(--ds-popover-border)]',
  'bg-[var(--ds-popover-bg)]',
  '[box-shadow:var(--effect-shadow-10)]',
  'outline-none',

  // Menu's entrance and exit, origin-aware; the reasoning is on `menuPanelRecipe`.
  '[transform-origin:var(--transform-origin,center)]',
  'transition-[opacity,scale] duration-[var(--motion-overlay)] ease-[var(--motion-overlay-ease)]',
  'data-[ending-style]:duration-[var(--motion-overlay-exit)]',
  'data-[ending-style]:ease-[var(--motion-overlay-exit-ease)]',
  'data-[starting-style]:opacity-0 data-[ending-style]:opacity-0',
  'motion-safe:data-[starting-style]:scale-[0.96] motion-safe:data-[ending-style]:scale-[0.96]',
]);

/** Same stacking reason as `menuPositionerRecipe`: above MUI's modal (1300), below its tooltip (1500). */
export const popoverPositionerRecipe = cva(['z-[1400]']);
